import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StatTooltip as NYYStatTooltip } from 'yankees-react-utils';
import { useOktaQuery, Definitions } from '../data';

const StatTooltip = ({ statistic, ...rest }) => {
    const tooltipEnabled = !window.$IsDugoutApp;
    const [toggled, setToggled] = useState(false);
    const { data, isLoading } = useOktaQuery(
        ['definition', statistic],
        (t) => Definitions.get(t, statistic),
        { enabled: !!toggled && tooltipEnabled },
    );
    if (!tooltipEnabled) return rest.children;

    const onToggle = (show) => {
        if (show) setToggled(true); // only enable once and don't disable to preserve cached value
    };

    return (
        <NYYStatTooltip onToggle={onToggle} isLoading={isLoading} definition={data} {...rest} />
    );
};

StatTooltip.propTypes = {
    statistic: PropTypes.string.isRequired,
};

export default StatTooltip;
